export const createName = name => `@@signal/${name}`

export const createSymbol = id => {
  return Symbol(createName(id))
}

export default createSymbol
